
<template>
  <div class="zebramo-screen row mt-4">

    <div class="col-md-3">





      <user-maxi-header :profile="profile" />





    </div>



    <div class="col-md-9">
      <loading-indicator v-if="loading" />

      <b-tabs class="zebramo-custom-tabs" fill v-else>

        <b-tab title="Satıcı olarak" active>

          <b-tabs class="p-2 review-inner-tabs" fill>
            <b-tab :title="seller_great_title" @click="fetch_seller_great()" active class="great-title mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="seller_reviews.great" :key="review.id" v-for="review in seller_reviews.great">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
            <b-tab :title="seller_good_title" @click="fetch_seller_good()" class="mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="seller_reviews.good" :key="review.id" v-for="review in seller_reviews.good">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
            <b-tab :title="seller_poor_title" @click="fetch_seller_poor()" class="mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="seller_reviews.poor" :key="review.id" v-for="review in seller_reviews.poor">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
          </b-tabs>

        </b-tab>

        <b-tab title="Alıcı olarak" @click="fetch_purchaser_great()">

          <b-tabs class="p-2 review-inner-tabs" fill>
            <b-tab :title="purchaser_great_title"  active class="mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="purchaser_reviews.great" :key="review.id" v-for="review in purchaser_reviews.great">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
            <b-tab :title="purchaser_good_title" @click="fetch_purchaser_good()" class="mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="purchaser_reviews.good" :key="review.id" v-for="review in purchaser_reviews.good">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
            <b-tab :title="purchaser_poor_title" @click="fetch_purchaser_poor()" class="mt-2">
              <ul class="list-unstyled">

                <li class="media" v-if="purchaser_reviews.poor" :key="review.id" v-for="review in purchaser_reviews.poor">
                  <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}">
                    <img class="user-img d-flex mr-3" :src="getImage(review)">
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ name: 'user-profile-screen', params: { id: review.owner.id }}"
                      class="username small font-weight-bold mt-0">
                      {{ review.owner.username }}
                    </router-link>
                    <span class="small text-muted-500"> {{ review.message }} </span>
                    <div class="date small text-muted"> {{ review.created|humanize }} </div>
                  </div>
                </li>

              </ul>
            </b-tab>
          </b-tabs>

        </b-tab>

      </b-tabs>
    </div>

  </div>
</template>

<script>
import UserMaxiHeader from '../misc/UserMaxiHeader'

export default {
  name: 'user-review-screen',

  props: ['id'],

  components: {
    UserMaxiHeader
  },

  data() {
    return {
      loading: true,

      profile: null,
      purchaser_reviews: {},
      seller_reviews: {},

      seller_great_title: '',
      seller_good_title: '',
      seller_poor_title: '',
      purchaser_great_title: '',
      purchaser_good_title: '',
      purchaser_poor_title: '',
    }
  },

  created() {
    this.fetch_data();
  },
  mounted() {
    this.fetch_seller_great()
  },
  methods: {
   async fetch_data() {
     await this.api.ops.GET.users_(this.id).then((data) => {
        this.api.patcher.patch_users_images({ items: [data.user] })
        this.profile = data.user;
        this.seller_great_title = "😃 Harika (" + this.profile.seller_rating.great + ")"
        this.seller_good_title = "☺️ Normal(" + this.profile.seller_rating.good + ")"
        this.seller_poor_title = "😞 Kötü(" + this.profile.seller_rating.poor + ")"

        this.purchaser_great_title = "😃 Harika(" + this.profile.purchaser_rating.great+ ")"
        this.purchaser_good_title = "☺️ Normal (" + this.profile.purchaser_rating.good + ")"
        this.purchaser_poor_title = "😞 Kötü  (" + this.profile.purchaser_rating.poor + ")"
      });
      this.loading = false
    },
    async fetch_seller_great(){
      if(this.seller_reviews.great === undefined){
      await this.api.ops.GET.users__reviews(this.id, {
        role: 'seller',
        rating: 'great'
      }).then(res => {
        for(let i = 0 ; i< res.user_reviews.great.items.length ; i++){
          if(res.user_reviews.great.items[i].owner.image){
            res.user_reviews.great.items[i].owner.image.url_template = res.user_reviews.great.items[i].owner.image.url_template.toString()
            res.user_reviews.great.items[i].owner.image.url_template = res.user_reviews.great.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
          }
        }
        this.seller_reviews.great = res.user_reviews.great.items
        this.$forceUpdate()
      })
      }
    },
    async fetch_seller_good(){
      if(this.seller_reviews.good === undefined){
        await this.api.ops.GET.users__reviews(this.id, {
          role: 'seller',
          rating: 'good'
        }).then(res => {
          for (let i = 0; i < res.user_reviews.good.items.length; i++) {
            if (res.user_reviews.good.items[i].owner.image) {
              res.user_reviews.good.items[i].owner.image.url_template = res.user_reviews.good.items[i].owner.image.url_template.toString()
              res.user_reviews.good.items[i].owner.image.url_template = res.user_reviews.good.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
            }
          }
          this.seller_reviews.good = res.user_reviews.good.items
          this.$forceUpdate()
        })
      }
    },
    async fetch_seller_poor(){
      if(this.seller_reviews.poor === undefined) {
        await this.api.ops.GET.users__reviews(this.id, {
          role: 'seller',
          rating: 'poor'
        }).then(res => {
          for (let i = 0; i < res.user_reviews.poor.items.length; i++) {
            if (res.user_reviews.poor.items[i].owner.image) {
              res.user_reviews.poor.items[i].owner.image.url_template = res.user_reviews.poor.items[i].owner.image.url_template.toString()
              res.user_reviews.poor.items[i].owner.image.url_template = res.user_reviews.poor.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
            }
          }
          this.seller_reviews.poor = res.user_reviews.poor.items
          this.$forceUpdate()
        })
      }
    },
    async fetch_purchaser_great(){
     if(this.purchaser_reviews.great === undefined){
      await this.api.ops.GET.users__reviews(this.id, {
        role: 'purchaser',
        rating: 'great'
      }).then(res => {
        for(let i = 0 ; i< res.user_reviews.great.items.length ; i++){
          if(res.user_reviews.great.items[i].owner.image){
            res.user_reviews.great.items[i].owner.image.url_template = res.user_reviews.great.items[i].owner.image.url_template.toString()
            res.user_reviews.great.items[i].owner.image.url_template = res.user_reviews.great.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
          }
        }
        this.purchaser_reviews.great = res.user_reviews.great.items
        this.$forceUpdate()
      })
     }
    },
    async fetch_purchaser_good(){
      if(this.purchaser_reviews.good === undefined) {
        await this.api.ops.GET.users__reviews(this.id, {
          role: 'purchaser',
          rating: 'good'
        }).then(res => {
          for (let i = 0; i < res.user_reviews.good.items.length; i++) {
            if (res.user_reviews.good.items[i].owner.image) {
              res.user_reviews.good.items[i].owner.image.url_template = res.user_reviews.good.items[i].owner.image.url_template.toString()
              res.user_reviews.good.items[i].owner.image.url_template = res.user_reviews.good.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
            }
          }
          this.purchaser_reviews.good = res.user_reviews.good.items
          this.$forceUpdate()
        })
      }
    },
    async fetch_purchaser_poor() {
      if (this.purchaser_reviews.poor === undefined) {
        await this.api.ops.GET.users__reviews(this.id, {
          role: 'purchaser',
          rating: 'poor'
        }).then(res => {
          for (let i = 0; i < res.user_reviews.poor.items.length; i++) {
            if(res.user_reviews.poor.items[i].owner.image){
              res.user_reviews.poor.items[i].owner.image.url_template = res.user_reviews.poor.items[i].owner.image.url_template.toString()
              res.user_reviews.poor.items[i].owner.image.url_template = res.user_reviews.poor.items[i].owner.image.url_template.replace(/\$\{resolution\}/g, '128x128')
            }
          }
          this.purchaser_reviews.poor = res.user_reviews.poor.items
          this.$forceUpdate()
        })
      }
    },
    getImage(review){
     if(review.owner.image)
       return review.owner.image.url_template
      else
        return require('../../assets/img/mobile-assets/user_placeholder_smallest.png')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/sass/zebramo-theme-vars";

.media {
  border-bottom: 1px solid $gray-200;
  margin-bottom: 15px;
  padding-bottom: 15px;
  .username {
    color: $mor0;
  }
  .date {
  }
}
  .great-title{
    content: "\01F354";
  }

</style>



// WEBPACK FOOTER //
// src/components/screens/UserReviewScreen.vue